<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul class="nav">
          <li class="nav-item">
            <router-link to="/blog" class="nav-link">{{ $t('blog') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/terms#terms-conditions" class="nav-link">{{ $t('terms_and_conditions') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/terms#privacy-policy" class="nav-link">{{ $t('privacy_policy') }}</router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="http://help.indiefy.net/" target="_blank">{{ $t('help') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" target="_blank" href="http://help.indiefy.net/">
              <i class="far fa-question-circle"></i>
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright ml-auto">&copy; {{ year }}, Indiefy Inc.</div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue